import URLConfig from './URLConfig';
import axiosInstance from "../util/axiosInstance";

const path = URLConfig.getBasePath();

// fired with the warning count whenever the Services page loads or changes, so the menu badge follows
export const SERVICES_CHANGED = 'mv-services-changed';

// Admin Services page. Admins only: a manager would get 403, and a 403 signs the user out, so callers must check
// AuthenticationService.canManageSettings() first.
class MonitorService {

    overview() {
        return axiosInstance().get(path + "/admin/services");
    }

    warnings() {
        return axiosInstance().get(path + "/admin/services/warnings");
    }

    refresh(key) {
        return axiosInstance().post(path + "/admin/services" + (key ? "/" + key : "") + "/refresh");
    }

    save(key, form) {
        return axiosInstance().put(path + "/admin/services/" + key, form);
    }
}

export default new MonitorService();
